import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  text: string }} Tooltip
 */

/**
 * @typedef {{
 *  id: number,
 *  name: string,
 *  updateDate: Date,
 *  updatedBy: number }} Form
 */

/**
 * @typedef {{
 *  id: number,
 *  code: string,
 *  type: string,
 *  text: string,
 *  helperText: string,
 *  url: string,
 *  tooltip: Tooltip }} FormField
 */

const api = new Api("api/Forms");
const formFieldApi = new Api("api/Forms/fields");

/**
 * @param {number} formId
 * @returns {Promise<AxiosResponse<FormField[]>>}
 */
export const getFormFieldsByFormId = (formId) => api.get(`${formId}/fields`);

/**
 * @returns {Promise<AxiosResponse<Form[]>>}
 */
export const getAll = () => api.get();

export const update = (id, payload) => formFieldApi.putId(id, payload);
